<template>
  <div
    class="footer"
    :class="{ 'footer--dark': $vuetify.theme.dark }"
  >
    <div class="container boxed-container w-full">
      <div class="d-flex justify-space-between">
        <div class="container">
          <div class="row">
            <div class="col">
              <h2 class="app-title text--primary">
                <v-img
                  :src="require('@/assets/images/logos/selfbio-logo-6.png')"
                  max-height="30px"
                  max-width="30px"
                  alt="logo"
                  contain
                  eager
                  class="app-logo me-3"
                  style="transform: scale(1.7); opacity: 0.9;"
                ></v-img>
                <span style="margin-left: 12px; padding-top: 7px;display: inline-block;"><span style="color: #9155fd">SELF</span>BIOGRAPHY</span>
              </h2>
            </div>
            <div class="col">
              <div class="social-links">
                <a href="javascript:;">
                  <v-tooltip
                    top
                    color="#000000"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        :class="{'alternate-icon-small': !mdiFacebook}"
                        class="mx-auto"
                        v-on="on"
                      >
                        {{ mdiFacebook }}
                      </v-icon>
                    </template>
                    <span>&nbsp;Coming Soon&nbsp;</span>
                  </v-tooltip>
                </a>
                <a href="javascript:;">
                  <v-tooltip
                    top
                    color="#000000"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        :class="{'alternate-icon-small': !mdiTwitter}"
                        class="mx-auto"
                        v-on="on"
                      >
                        {{ mdiTwitter }}
                      </v-icon>
                    </template>
                    <span>&nbsp;Coming Soon&nbsp;</span>
                  </v-tooltip>
                </a>
                <a href="javascript:;">
                  <v-tooltip
                    top
                    color="#000000"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        :class="{'alternate-icon-small': !mdiInstagram}"
                        class="mx-auto"
                        v-on="on"
                      >
                        {{ mdiInstagram }}
                      </v-icon>
                    </template>
                    <span>&nbsp;Coming Soon&nbsp;</span>
                  </v-tooltip>
                </a>
                <a href="javascript:;">
                  <v-tooltip
                    top
                    color="#000000"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        :class="{'alternate-icon-small': !mdiLinkedin}"
                        class="mx-auto"
                        v-on="on"
                      >
                        {{ mdiLinkedin }}
                      </v-icon>
                    </template>
                    <span>&nbsp;Coming Soon&nbsp;</span>
                  </v-tooltip>
                </a>
                <a href="javascript:;">
                  <v-tooltip
                    top
                    color="#000000"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        :class="{'alternate-icon-small': !mdiTelegram}"
                        class="mx-auto"
                        v-on="on"
                      >
                        {{ mdiTelegram }}
                      </v-icon>
                    </template>
                    <span>&nbsp;Coming Soon&nbsp;</span>
                  </v-tooltip>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="container row wrapper-menu-footer">
      <div class="footer-col">
        <h4 class="text-overline">
          <button
            type="button"
            class="footer-section-toggle"
            :disabled="!$vuetify.breakpoint.smAndDown"
            :aria-expanded="!$vuetify.breakpoint.smAndDown || expandedSections.about"
            aria-controls="footer-about"
            @click="expandedSections.about = !expandedSections.about"
          >
            About
            <v-icon
              class="d-md-none"
              small
            >
              {{ expandedSections.about ? mdiChevronUp : mdiChevronDown }}
            </v-icon>
          </button>
        </h4>
        <ul
          v-show="!$vuetify.breakpoint.smAndDown || expandedSections.about"
          id="footer-about"
        >
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">Self Biography</span>
                  <v-icon
                    v-if="$store.state.level == 1"
                    class="mx-auto"
                    @click="editPage(400)"
                  >{{ mdiPlaylistEdit }}</v-icon>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">Credits and Gratitude</span>
                  <v-icon
                    v-if="$store.state.level == 1"
                    class="mx-auto"
                    @click="editPage(401)"
                  >{{ mdiPlaylistEdit }}</v-icon>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">The Company</span>
                  <v-icon
                    v-if="$store.state.level == 1"
                    class="mx-auto"
                    @click="editPage(402)"
                  >{{ mdiPlaylistEdit }}</v-icon>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">Security</span>
                  <v-icon
                    v-if="$store.state.level == 1"
                    class="mx-auto"
                    @click="editPage(403)"
                  >{{ mdiPlaylistEdit }}</v-icon>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-col">
        <h4 class="text-overline">
          <button
            type="button"
            class="footer-section-toggle"
            :disabled="!$vuetify.breakpoint.smAndDown"
            :aria-expanded="!$vuetify.breakpoint.smAndDown || expandedSections.resources"
            aria-controls="footer-resources"
            @click="expandedSections.resources = !expandedSections.resources"
          >
            Resources
            <v-icon
              class="d-md-none"
              small
            >
              {{ expandedSections.resources ? mdiChevronUp : mdiChevronDown }}
            </v-icon>
          </button>
        </h4>
        <ul
          v-show="!$vuetify.breakpoint.smAndDown || expandedSections.resources"
          id="footer-resources"
        >
          <li>
            <a href="javascript:;">
              <span @click="$store.commit('setAgreements', true);">User Agreements</span>
              <v-icon
                v-if="$store.state.level == 1"
                class="mx-auto"
                @click="editPage(411)"
              >{{ mdiPlaylistEdit }}</v-icon>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">Documentation</span>
                  <v-icon
                    v-if="$store.state.level == 1"
                    class="mx-auto"
                    @click="editPage(406)"
                  >{{ mdiPlaylistEdit }}</v-icon>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">FAQ</span>
                  <v-icon
                    v-if="$store.state.level == 1"
                    class="mx-auto"
                    @click="editPage(407)"
                  >{{ mdiPlaylistEdit }}</v-icon>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">Support</span>
                  <v-icon
                    v-if="$store.state.level == 1"
                    class="mx-auto"
                    @click="editPage(408)"
                  >{{ mdiPlaylistEdit }}</v-icon>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-col">
        <h4 class="text-overline">
          <button
            type="button"
            class="footer-section-toggle"
            :disabled="!$vuetify.breakpoint.smAndDown"
            :aria-expanded="!$vuetify.breakpoint.smAndDown || expandedSections.plans"
            aria-controls="footer-plans"
            @click="expandedSections.plans = !expandedSections.plans"
          >
            Plans
            <v-icon
              class="d-md-none"
              small
            >
              {{ expandedSections.plans ? mdiChevronUp : mdiChevronDown }}
            </v-icon>
          </button>
        </h4>
        <ul
          v-show="!$vuetify.breakpoint.smAndDown || expandedSections.plans"
          id="footer-plans"
        >
          <li>
            <a href="/pages/pricing">Plans</a>
          </li>
          <li>
            <router-link to="/referrals">Affiliate Program</router-link>
          </li>
        </ul>
      </div>

      <div class="footer-col">
        <h4 class="text-overline">
          <button
            type="button"
            class="footer-section-toggle"
            :disabled="!$vuetify.breakpoint.smAndDown"
            :aria-expanded="!$vuetify.breakpoint.smAndDown || expandedSections.social"
            aria-controls="footer-social"
            @click="expandedSections.social = !expandedSections.social"
          >
            Social
            <v-icon
              class="d-md-none"
              small
            >
              {{ expandedSections.social ? mdiChevronUp : mdiChevronDown }}
            </v-icon>
          </button>
        </h4>
        <ul
          v-show="!$vuetify.breakpoint.smAndDown || expandedSections.social"
          id="footer-social"
        >
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">Facebook</span>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">Twitter</span>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">LinkedIn</span>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">Telegram</span>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
          <li>
            <a href="javascript:;">
              <v-tooltip
                right
                color="#000000"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">Discord</span>
                </template>
                <span>&nbsp;Coming Soon&nbsp;</span>
              </v-tooltip>
            </a>
          </li>
        </ul>
      </div>
      <ModalPages
        v-if="$store.state.edit_pages && $store.state.level == 1"
        :page="page"
        @page_id="callPage"
      />
      <Agreements
        v-if="$store.state.agreements"
        class="mb-6"
      />
      <ModalGallery
        v-if="$store.state.gallery.open"
        class="mb-6"
      />
    </div>
    <div class="version-text">
      v0.1.0
    </div>
  </div>
</template>
<script>
import {
  mdiFacebook, mdiTwitter, mdiInstagram, mdiLinkedin, mdiTelegram, mdiDiscord, mdiPlaylistEdit, mdiChevronDown, mdiChevronUp,
} from '@mdi/js'
import ModalPages from '@/components/modals/ModalPages.vue'
import Agreements from '@/components/Agreements.vue'
import ModalGallery from '@/components/modals/ModalGallery.vue'

export default ({
  components: {
    ModalPages,
    ModalGallery,
    Agreements,
  },
  data() {
    return {
      mdiFacebook,
      mdiTwitter,
      mdiInstagram,
      mdiLinkedin,
      mdiTelegram,
      mdiDiscord,
      mdiPlaylistEdit,
      page: null,
      mdiChevronDown,
      mdiChevronUp,
      expandedSections: {
        about: false, resources: false, plans: false, social: false,
      },
    }
  },
  methods: {
    callPage(page) {
      if (page === 410) {
        this.$router.push({ path: '/pages/pricing' })
      } else {
        this.$router.push({ path: `/page/${page}` }).catch(() => {
          this.$router.go()
        })
      }
    },
    editPage(page) {
      this.page = page
      this.$store.commit('showEditPages', true)
    },
  },
})
</script>

<style scoped lang="scss">
.footer {
  --footer-text: rgba(94, 86, 105, 0.87);
  --footer-muted: rgba(94, 86, 105, 0.68);
  --footer-divider: rgba(94, 86, 105, 0.2);
  --footer-hover: rgba(94, 86, 105, 0.08);
  color: var(--footer-text);

  &.footer--dark {
    --footer-text: rgba(231, 227, 252, 0.87);
    --footer-muted: rgba(231, 227, 252, 0.68);
    --footer-divider: rgba(231, 227, 252, 0.16);
    --footer-hover: rgba(231, 227, 252, 0.08);

    .app-logo { filter: brightness(0) invert(1); }
  }

  ul {
    padding: 0;
  }

  padding: 0 0 50px;
  width: 100%;

  .col,
  .footer-col {
    width: 25%;
    padding: 0 15px;
  }

  .col {
    width: 50%;
  }

  h4 {
    font-size: 22px;
    color: inherit;
    text-transform: capitalize;
    margin-bottom: 35px;
    font-weight: 500;
    position: relative;
  }

  h4::before {
    content: '';
    position: absolute;
    left:0;
    bottom: -10px;
    background-color: #9155fd;
    height: 2px;
    box-sizing: border-box;
    width: 50px;
  }

  ul li:not(:last-child) {
    margin-bottom: 10px;
  }

  ul li a {
    font-size: 14px;
    text-transform: capitalize;
    text-decoration: none;
    font-weight: 300;
    color: var(--footer-text);
    display: block;
    transition: all 0.3s ease;

    span {
      margin-right: 5px;
    }
  }

  ul li a:hover {
    padding-left: 8px;
    text-decoration: underline;
  }

  #footer-plans a {
    border-bottom: 0;
  }

  .social-links {
    float: right;
    padding: 20px 0 16px;
    margin-right: -10px;
  }

  .social-links a {
    display: inline-block;
    height: 40px;
    width: 40px;
    background-color: transparent;
    margin: 0 10px 10px 0;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    transition: all 0.5s ease;

    &:last-child {
      margin-right: 0;
    }
  }

  .social-links a:hover {
    color: var(--footer-text);
    background-color: var(--footer-hover);
  }

  .boxed-container, .wrapper-menu-footer {
    max-width: 1420px;
    margin-left: auto;
    margin-right: auto;
    padding: 0;

    .container {
      padding: 0;
    }
  }

  .wrapper-menu-footer {
    position: relative;
    left: 20px;
    padding-left: 8%;
    width: 100%;
    margin: 0 auto;
    padding-top: 30px;
  }

  hr {
    border: 0;
    border-top: 1px solid var(--footer-divider);
  }

  .app-title {
    margin: 20px 0 30px;
  }

  .app-logo {
    float: left;
    position: relative;
    top: 5px;
  }

  .version-text {
    width: 100%;
    text-align: center;
    margin-top: 10px;
    color: var(--footer-muted);
    font-size: 13px;
  }
}

.footer-section-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  text-align: left;
}

/*responsive*/
@media (max-width: 959px) {
  .footer {
    position: static !important;
    padding-bottom: 16px;

    .boxed-container { padding: 16px 24px 8px; }
    .row { margin: 0; }
    .col { width: 100%; flex-basis: initial; padding: 0; }
    .app-title { width: 240px; margin: 0 auto 8px; font-size: 18px; }
    .social-links { float: none; display: flex; justify-content: center; gap: 8px; margin: 0; padding: 0; }
    .social-links a { margin: 0; }
    .wrapper-menu-footer { left: 0; padding: 0 24px; }
    .footer-col { width: 100%; padding: 0; margin: 0; border-bottom: 1px solid var(--footer-divider); }
    h4 { margin: 0; }
    h4::before { display: none; }
    .footer-section-toggle { min-height: 48px; cursor: pointer; }
    ul { padding: 0 0 12px; list-style: none; }
    ul li { margin: 0; }
    ul li a { padding: 8px 0; }
    .version-text { margin-top: 12px; }
  }
}
</style>
